import React from "react";
import { MessageActions, UIAction, GeneratedPostsData } from "../types";
import { ACTION_CONFIG } from "../config/actionConfig";

/** Match suggestion chip text (outline pills use near-primary icon tone). */
const iconClass =
  "h-3.5 w-3.5 flex-shrink-0 text-theme-fg/85 sm:h-4 sm:w-4";

function SuggestionIcon({ type }: { type: string }) {
  switch (type) {
    case "save_post":
      return (
        <svg className={iconClass} fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4" />
        </svg>
      );
    case "schedule_post":
      return (
        <svg className={iconClass} fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
        </svg>
      );
    case "generate_image":
    case "include_image":
    case "create_post_with_image":
      return (
        <svg className={iconClass} fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
        </svg>
      );
    case "create_blog":
    case "refine_ideas":
      return (
        <svg className={iconClass} fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
      );
    case "learn_more":
      return (
        <svg className={iconClass} fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      );
    case "convert_to_linkedin":
    case "generate_posts":
    case "create_posts_all_platforms":
      return (
        <svg className={iconClass} fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z" />
        </svg>
      );
    case "research_topic":
      return (
        <svg className={iconClass} fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
        </svg>
      );
    case "regenerate":
      return (
        <svg className={iconClass} fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
        </svg>
      );
    case "write_script":
      return (
        <svg className={iconClass} fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
        </svg>
      );
    case "view_images_on_library":
      return (
        <svg className={iconClass} fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14M4 8h16M4 16h16" />
        </svg>
      );
    case "insert_image_to_the_post":
      return (
        <svg className={iconClass} fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
        </svg>
      );
    case "check_availability":
    case "book_appointment":
      return (
        <svg className={iconClass} fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
        </svg>
      );
    default:
      return (
        <svg className={iconClass} fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
        </svg>
      );
  }
}

interface ActionButtonsProps {
  /** Legacy: social_post_created with publish/schedule */
  actions?: MessageActions | null;
  /** New: array of actions from backend (social_posts, images, suggested_actions) */
  uiActions?: UIAction[] | null;
  onPublish?: (postData: MessageActions["post_data"]) => void;
  onSchedule?: (postData: MessageActions["post_data"]) => void;
  /** New: called when user clicks an action from uiActions (chat vs direct handled by parent) */
  onActionClick?: (action: UIAction, context?: ActionClickContext) => void;
  isPublishing?: boolean;
  isScheduling?: boolean;
  isLoading?: boolean;
}

/** Optional context so parent can resolve save_post/schedule_post (e.g. post from generatedPosts by index). */
export interface ActionClickContext {
  generatedPosts?: GeneratedPostsData;
}

export const ActionButtons: React.FC<ActionButtonsProps> = ({
  actions,
  uiActions,
  onPublish,
  onSchedule,
  onActionClick,
  isPublishing = false,
  isScheduling = false,
  isLoading = false,
}) => {
  // In-thread suggestions: outlined pills + divider (clear type), compact, left-aligned wrap — matches reference layout.
  if (uiActions && uiActions.length > 0 && onActionClick) {
    const pillClass =
      "inline-flex max-w-full items-center gap-1.5 rounded-full border border-theme-border bg-transparent px-2 py-1 text-left text-[11px] font-medium leading-snug text-theme-fg transition-colors hover:border-theme-fg/20 hover:bg-theme-secondary/10 disabled:cursor-not-allowed disabled:opacity-50 sm:gap-2 sm:px-2.5 sm:py-1.5 sm:text-xs";
    return (
      <div className="mt-3 w-full max-w-full">
        <div className="mb-2 flex w-full items-center gap-3">
          <div className="h-px min-w-0 flex-1 bg-theme-border" aria-hidden />
          <span className="shrink-0 text-[11px] font-bold uppercase tracking-[0.18em] text-theme-fg-muted">
            Suggestions
          </span>
          <div className="h-px min-w-0 flex-1 bg-theme-border" aria-hidden />
        </div>
        <div className="flex flex-wrap content-start justify-start gap-x-2 gap-y-1.5">
          {uiActions.map((action, idx) => {
            const config = ACTION_CONFIG[action.type];
            const label = action.label ?? config?.defaultLabel ?? action.type;
            const isDirect = config?.handler === "direct";
            const disabled =
              isLoading ||
              (isDirect && action.type === "save_post" && isPublishing) ||
              (isDirect && action.type === "schedule_post" && isScheduling);
            return (
              <button
                key={`${action.type}-${idx}`}
                type="button"
                onClick={() => onActionClick(action)}
                disabled={disabled}
                className={pillClass}
              >
                {action.type === "save_post" && isPublishing ? (
                  <>
                    <span className="inline-block h-3.5 w-3.5 animate-spin rounded-full border-2 border-theme-fg-muted/40 border-t-transparent" />
                    <span>Saving...</span>
                  </>
                ) : action.type === "schedule_post" && isScheduling ? (
                  <>
                    <span className="inline-block h-3.5 w-3.5 animate-spin rounded-full border-2 border-theme-fg-muted/40 border-t-transparent" />
                    <span>Scheduling...</span>
                  </>
                ) : (
                  <>
                    <SuggestionIcon type={action.type} />
                    <span className="text-balance">{label}</span>
                  </>
                )}
              </button>
            );
          })}
        </div>
      </div>
    );
  }

  // Legacy: social_post_created with publish/schedule
  if (actions?.type === "social_post_created" && onPublish && onSchedule) {
    return (
      <div className="mt-3 flex gap-3">
        {actions.actions.includes("publish") && (
          <button
            onClick={() => onPublish(actions.post_data)}
            disabled={isPublishing || isLoading}
            className="flex items-center gap-2 rounded-lg bg-theme-primary px-4 py-2 text-white transition-colors hover:opacity-90 disabled:cursor-not-allowed disabled:opacity-50"
          >
            {isPublishing ? (
              <>
                <svg
                  className="animate-spin h-4 w-4"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  />
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  />
                </svg>
                Publishing...
              </>
            ) : (
              <>
                <svg
                  className="w-4 h-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                  />
                </svg>
                Publish Now
              </>
            )}
          </button>
        )}
        {actions.actions.includes("schedule") && (
          <button
            onClick={() => onSchedule(actions.post_data)}
            disabled={isScheduling || isLoading}
            className="px-4 py-2 bg-[#e4b372] text-[#2f4941] rounded-lg hover:bg-[#d9a865] transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
          >
            <svg
              className="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
              />
            </svg>
            Schedule
          </button>
        )}
      </div>
    );
  }

  return null;
};
